import * as React from 'react';
import type { ResolveThunks } from 'react-redux';
import { connect } from 'react-redux';
import type { CustomRouteComponentProps } from 'react-router-dom';

import type { CompanyViewModel } from 'ab-viewModels/company.viewModel';

import type { RootState } from 'af-reducers';

import Breadcrumbs from 'af-components/Breadcrumbs';

import * as CompanyActions from 'af-actions/companies';

import EmployeeStatusSettingsEdit from './EmployeeStatusSettings/EmployeeStatusSettingsEdit';
import EmployeeStatusSettingsPreview from './EmployeeStatusSettings/EmployeeStatusSettingsPreview';
import Loading from './Loading';

interface CompanySettingsRouteProps {
	orgAlias: string;
	companyName: string;
}

interface DispatchProps {
	getCompany: typeof CompanyActions.getCompany;
}

interface StateProps {
	company: Nullable<CompanyViewModel>;
}

type OwnProps = CustomRouteComponentProps<CompanySettingsRouteProps>;

type Props = StateProps & ResolveThunks<DispatchProps> & OwnProps;

interface State {
	showEmployeeStatusSettingsModal: boolean;
}

class LaborDetails extends React.PureComponent<Props, State> {

	state: State = {
		showEmployeeStatusSettingsModal: false,
	};

	async componentDidMount() {
		const { getCompany } = this.props;
		await getCompany();
	}

	toggleEmployeeStatusSettingsEdit = async () => {
		this.setState(
			(prevStatus: State) => ({ showEmployeeStatusSettingsModal: !prevStatus.showEmployeeStatusSettingsModal })
		);
	};

	render() {
		const { company } = this.props;
		const { showEmployeeStatusSettingsModal } = this.state;

		if (!company) {
			return <Loading />;
		}

		return (
			<div className="form-segment">
				<Breadcrumbs items={[{ label: 'Status' }]} />
				<EmployeeStatusSettingsPreview
					company={company}
					toggleEdit={this.toggleEmployeeStatusSettingsEdit}
				/>
				<EmployeeStatusSettingsEdit
					isVisible={showEmployeeStatusSettingsModal}
					toggleEdit={this.toggleEmployeeStatusSettingsEdit}
				/>
			</div>
		);
	}
}

function mapStateToProps(state: RootState): StateProps {
	const { company } = state.company;

	return {
		company,
	};
}

function mapDispatchToProps(): DispatchProps {
	return {
		getCompany: CompanyActions.getCompany,
	};
}

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps())(LaborDetails);
